import { BaseModel } from './profile.model';
import { Attachment } from './generic.model';
import { Country } from './masterdata.model';

export class SupplierBase {
    id: number;
    name: string;
}

export class Contact {
    id: number;
    stageId: string;
    operation: string;
    firstName: string;
    languageCode: string;
    language: string;
    lastName: string;
    fax: string;
    email: string;
    phone: string;
    mobile: string;
    jobTitle: string;
    comment: string;
    types: string[];
    supplierCodes: string[];
    contactId: number;
    ssoId: string;
    isPrimaryAccount: boolean;
    supplierPortalAccountID: number;
}

export class JobTitle extends BaseModel {
    name: string;
}

export class Department extends BaseModel {
    name: string;
}

export class JobRole extends BaseModel {
    supplierCode: string;
    profileId: number;
    jobTitleId: number;
    jobTitle: string;
    departmentId: number;
    department: string;
}

export class ServiceType extends BaseModel {
    type: string;
}

export class ExternalPartnerCertification {
    supplierCode: string;
    externalPartnerId: number;
    certificationTypeId: number;
    certificationType: string;
    certifiedDate: Date;
    expirationDate: Date | null;
    certifierName: string;
    attachments: Attachment[] = [];
    newFiles: File[] = [];
}

export class ExternalPartner extends BaseModel {
    supplierCode: string;
    profileId: number;
    serviceTypeId: number;
    serviceType: string;
    jobTitleId: number;
    jobTitle: string;
    departmentId: number;
    department: string;
    companyName: string;
    location: string;
    address1: string;
    address2: string;
    address3: string;
    city: string;
    state: string;
    zipCode: string;
    countryId: number;
    country: Country;
    acreditations: ExternalPartnerCertification[] = [];
}

export class ValidationTask {
    id: number;
    isPortalTaskBased: boolean;
    supplierCode: string;
    email: string;
    statusId: number;
    status: string;
    taskStartDate: Date;
    dueDate: Date;
    dueDateValue: string;
    enabled: boolean;

}
